import axios from 'axios';
let host = '';
host = 'https://vlab.uestc.edu.cn/finance';

export default {
    ticket: `${host}/liuwanr/userInfo/loginUserFromILab`,
    logins: `${host}/liuwanr/userInfo/logins`, //登录
    logout: `${host}/liuwanr/userInfo/logout`, //退出登录
    resetUserPwd: `${host}/liuwanr/userInfo/resetUserPwd`, //更改密码
    isRequiredReset: `${host}/liuwanr/userInfo/isRequiredReset`, //密码是否为默认密码
    getAccountPassword: `${host}/evaluation/tms/userInfo/getAccountPassword`, //获取账号密码
    queryToken: `${host}/liuwanr/userInfo/queryToken`,
    save: `${host}/evaluation/tms/userInfo/add`, //注册
    updateLogInNumber: `${host}/liuwanr/userInfo/updateLogInNumber`, //用户登录修改登录次数和登陆时间
    uploadUserAvatars: `${host}/liuwanr/userInfo/uploadUserAvatars`, //上传头像
    loginSchool: `${host}/liuwanr/userInfo/loginSchoolClient`, //登陆查询学校
    loginRole: `${host}/liuwanr/userInfo/loginRole`, //登陆查询角色
    queryCourseDiscipline: `${host}/liuwanr/course/queryCourseDiscipline`, //查询课程学科
    queryCourseProfessionalClass: `${host}/liuwanr/course/queryCourseProfessionalClass`, //查询专业类
    queryCourseProfessional: `${host}/liuwanr/course/queryCourseProfessional`, //查询专业
    queryPhone: `${host}/liuwanr/userInfo/queryPhone`, //查询电话是否存在
    queryAccountIsExist: `${host}/evaluation/userInfo/queryAccountIsExist`, //查询员工，学生账号是否存在接口
    getRandomProAccount: `${host}/evaluation/tms/userInfo/getRandomProAccount`, //获取专家账号
    loginProfessor: `${host}/liuwanr/userInfo/login/professor`, // 检查专家验证码
    queryWorkNumberIsExist: `${host}/evaluation/tms/userInfo/queryWorkNumberIsExist`, //查询学号、工号是否存在
    queryStaffPAN: `${host}/liuwanr/staffProfessionalArchitecture/queryStaffPAN`, //查询员工专业是否存在
    queryProvince: `${host}/liuwanr/province/queryProvince`, //查询省份
    queryCity: `${host}/liuwanr/city/queryCity`, //查询城市
    querySchoolData: `${host}/liuwanr/customer/querySchool`, //根据学校名称查询学校信息
    loginSchoolPerson: `${host}/liuwanr/userInfo/loginSchoolPerson`, //校内人员登录认证

    findPasswordByEmail: `${host}/evaluation/tms/userInfo/findPasswordByEmail`,
    findPasswordByPhone: `${host}/evaluation/tms/userInfo/findPasswordByPhone`,
    resetPassword: `${host}/evaluation/tms/userInfo/resetPassword`,
    checkCode: `${host}/evaluation/tms/userInfo/checkCode`,
    getCoursevideo: `${host}/evaluation/tms/classTech/simulationPlayList`, //开始课程-课程视频
    queryPersonalCenter: `${host}/evaluation/personalCenter/queryPersonalCenter`,
    getAccessNum: `${host}/evaluation/tms/userInfo/getAccessNum`, //获取项目访问量
    getValidateCode: `${host}/evaluation/tms/userInfo/getValidateCode`, //获取图形验证码

    examinePassword: `${host}/evaluation/tms/user/examinePassword`, //更换密码
    userinfoUpdate: `${host}/evaluation/tms/user/update`, //个人中心信息修改
    userinfo: `${host}/evaluation/tms/user/userinfo`, //个人中心信息展示
    sendEmailCode: `${host}/evaluation/tms/user/sendEmailCode`, //发送邮箱验证码
    bingEmail: `${host}/evaluation/tms/user/bingEmail`, //邮箱验证并更新
    sendPhoneCode: `${host}/evaluation/tms/user/sendPhoneCode`, //发送手机验证码
    bindPhone: `${host}/evaluation/tms/user/bindPhone`, //校验手机验证码

    // 测评
    canExperiment: `${host}/evaluation/tms/evaluationrecord/can_experiment`, //查询是否能够开启实验
    openExercise: `${host}/evaluation/tms/evaluationrecord/openExercise`, //查询是否能够开启虚拟仿真实验
    openExerciseOrTeaching: `${host}/evaluation/tms/evaluationrecord/openExerciseOrTeaching`, //查询是否能够开启虚拟仿真实验
    openTeaching: `${host}/evaluation/tms/evaluationrecord/openTeaching`, //查询是否能够开启教学实验
    experimentDetail: `${host}/evaluation/tms/evaluationrecord/detail`, //成绩详情
    experimentNext: `${host}/evaluation/tms/evaluationrecord/next`, //下一题
    experimentNotmade: `${host}/evaluation/tms/evaluationrecord/not_made`, //提交之前查询是否还有未做完的试题
    experimentPrevious: `${host}/evaluation/tms/evaluationrecord/previous`, //上一题
    experimentRemaining: `${host}/evaluation/tms/evaluationrecord/remaining`, //获取测评剩余时间
    experimentStart: `${host}/evaluation/tms/evaluationrecord/start`, //开始测评
    experimentSubmit: `${host}/evaluation/tms/evaluationrecord/submit`, //提交测评
    queryProjectIdAndPattenById: `${host}/evaluation/tms/exp/queryProjectIdAndPattenById`, //基于考核id查询项目id

    // 实验记录
    fictitiousRecord: `${host}/evaluation/fictitious/projectrecord/user/kdRecord`, //用户端实验记录
    exportProjectRecord: `${host}/evaluation/fictitious/projectrecord/user/exportProjectRecord`, //虚拟实验记录导出
    exportExperimentProjectRecord: `${host}/evaluation/fictitious/projectrecord/user/exportExperimentProjectRecord`, //个人实验记录导出
    exportKdTeachReport: `${host}/evaluation/fictitious/projectrecord/user/exportKdTeachReport`, //个人教学实验记录导出(新考核)
    fictitiousScore: `${host}/evaluation/fictitious/projectrecord/user/score`, //个人实验概览
    experimentRecord: `${host}/evaluation/fictitious/projectrecord/user/experimentRecord`, //用户端教学实验记录
    reportSignature: `${host}/evaluation/signature/reportSignature`,

    // 我的考核
    joinPractice: `${host}/evaluation/tms/classTech/joinPractice`, //通过邀请码进入实验
    queryArchievement: `${host}/evaluation/tms/classTech/queryExperimentalReport`, //查看教学实验报告
    queryVirtualReport: `${host}/evaluation/tms/classTech/queryVirtualReport`, //查看虚仿实验报告
    checkInvitationCode: `${host}/evaluation/tms/classTech/checkInvitationCode`, //校验是否需要邀请码
    userRecord: `${host}/evaluation/tms/classTech/userRecord`, //查询班级实验列表信息
    getReport: `${host}/evaluation/Achievement/getReport`,
    uploadSignature: `${host}/evaluation/evaluation/signature/uploadSignature`,
    getItemContentByIds: `${host}/kdSys/getItemContentByIds`,
    commitReport: `${host}/kdSys/step/commitReport`, //专家登录清除数据
    queryItem: `${host}/kdSys/queryItem`,
    mineClass: `${host}/evaluation/student/assessment/mineClass`,
    stuAssessmentByScreen: `${host}/evaluation/student/assessment/stuAssessmentByScreen`
};
